import { Avatar, Box } from "@mui/material";
import PropTypes from "prop-types";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

export const IdentityCard = ({ name, phone, email, profile_picture_url }) => {
    const { getFontSize, getSectionStyle } = useResponsiveStyles();

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mt: 1,
                mb: 0.5,
            }}
        >
            <Avatar
                sx={{
                    ...styles.avatar,
                    ...getSectionStyle("identity-card-image"),
                }}
                variant="rounded"
                src={profile_picture_url || undefined}
                alt={name}
            >
                {!profile_picture_url && (
                    <span>{name.charAt(0)?.toUpperCase()}</span>
                )}
            </Avatar>
            <div className="flex flex-col">
                <h2
                    className="font-bold font-arial text-[#4C4E64]"
                    style={getFontSize("identity-card-name")}
                >
                    {name}
                </h2>
                <p
                    className="font-normal text-[#4C4E64]"
                    style={getFontSize("identity-card-info")}
                >
                    Ph: {phone}
                </p>
                <p
                    className=" text-primary underline font-normal"
                    style={getFontSize("identity-card-info")}
                >
                    {email}
                </p>
            </div>
        </Box>
    );
};

const styles = {
    avatar: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
};

IdentityCard.propTypes = {
    name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    profile_picture_url: PropTypes.string,
};
